export default "__VITE_ASSET__A0dgmF2O__"